import { useAuth } from "@/contexts/AuthContext";
import { AppBar, Toolbar, useTheme } from "@mui/material";
import UserMenu from "./UserMenu";
import { ThemeModeToggle } from "./ThemeModeToggle";
import {
  APP_BAR_HEIGHT_PX,
  APP_BAR_LOGO_MAX_HEIGHT_PX,
  DEFAULT_BUSINESS_UNIT_LOGO_URL,
} from "@/constants/branding";

interface IHeaderProps {
  inset: boolean;
  drawerWidth?: number;
}

export const Header = (props: IHeaderProps) => {
  const { user } = useAuth();
  const email = user?.email;
  const buName = user?.currentBusinessUnit?.name;
  const buLogoUrl = (user as { currentBusinessUnit?: { logoUrl?: string | null } })
    ?.currentBusinessUnit?.logoUrl;
  const theme = useTheme();

  return (
    <AppBar
      key={email}
      style={{ backgroundColor: theme.palette.primary.main }}
      position="fixed"
      sx={{
        width: { sm: "100%" },
      }}
      elevation={0}
    >
      <Toolbar
        sx={{
          minHeight: APP_BAR_HEIGHT_PX,
          py: 0.5,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginRight: "16px",
            height: APP_BAR_HEIGHT_PX - 8,
            maxHeight: "100%",
          }}
        >
          <img
            src={buLogoUrl || DEFAULT_BUSINESS_UNIT_LOGO_URL}
            alt={buName ? `${buName} logo` : "App logo"}
            style={{
              height: "100%",
              maxHeight: APP_BAR_LOGO_MAX_HEIGHT_PX,
              width: "auto",
              maxWidth: "min(280px, 40vw)",
              objectFit: "contain",
            }}
          />
        </div>

        <div
          style={{
            marginLeft: props.inset === true ? (props.drawerWidth || 240) : 0,
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            flexGrow: 1,
            transition: "margin-left 0.3s ease",
          }}
        >
          <div
            style={{
              cursor: "pointer",
              fontSize: 12,
              display: "flex",
              alignItems: "center",
              gap: "12px",
              color: theme.palette.primary.contrastText,
            }}
          >
            <ThemeModeToggle />
            <div style={{ color: theme.palette.primary.contrastText, textAlign: "right" }}>
              {buName ? (
                <span style={{ display: "block", fontSize: 11, opacity: 0.9 }}>{buName}</span>
              ) : null}
              <span>{email || ""}</span>
            </div>
            <UserMenu />
          </div>
        </div>
      </Toolbar>
    </AppBar>
  );
};
